module.exports = __webpack_public_path__ + "static/media/DaxlinePro-Light.2da60d3e.woff";